export const formMessageConstants = {

    formBannerTitle: 'Join The One Club',
    formBannerMessage: 'Creating an account will only take a few minutes and will allow you to buy tickets straight away.',

    yourDetails: 'Your details',
    signInHere: 'Sign in here',
    signIn: 'Sign in',
    reset: 'Reset',
    verifyEmail: 'Verify',

    alreadyAMember: 'Already a member?',
    rememberPassword: 'Remember your password?',
    signInWithDifferentAccount: 'Sign in with a different account?',
    resendVerificationEmail: 'Re-send email verification',

    registerHere: 'Register here',
    haventGotAnAccount: 'Haven\'t got an account?',

    forgottenPassword: 'Forgotten password',
    forgotPassword: 'Forgot password?',
    resetForgottenPassword: 'Please enter your email address to reset the forgotten password.',

    resetPassword: 'Reset password',
    resetPasswordFormHeaderLabel: 'Please enter your account\'s email address, verification code and new password',
    newPasswordRequired: 'New password required',

    changePassword: 'Change Password',
    saveUserDetails: 'Save details',
    editUserDetails: 'Edit details',
    upgradeTicketingUserDetails: 'Upgrade to Ticketing',
    upgradeMemberPlusUserDetails: 'Upgrade to Member Plus',
    seeDetails: 'See details',
    viewTickets: 'View tickets',

    noAddressesFound: 'No address has been found.',
    addNewAddress: 'Add new address',
    saveAddress: 'Save address',
    updateAddress: 'Update address',
    editAddress: 'Edit address',
    removeAddress: 'Remove address',

    cannotRemoveLastAddress: 'Cannot remove the last address.',
    cannotRemoveMainAddress: 'Cannot remove the main address',
    cannotRemoveShippingAddress: 'Cannot remove the shipping address',
    cannotRemoveBillingAddress: 'Cannot remove the billing address',

    emailAddressLabel: 'Email Address',
    passwordLabel: 'Password',
    confirmPasswordLabel: 'Confirm password',
    verificationCodeLabel: 'Verification Code',

    updateNotificationSettings: 'Update Notification Settings',

    submitOneClubFormButtonText: 'JOIN THE ONE CLUB',
    updateOneClubDetails: 'Update',
    submitDefaultFormButtonText: 'SIGN UP',
    submitTicketingFormButtonText: 'SIGN UP',
    submitBallotSummaryFormButtonText: 'Update',
    upgradeAccount: 'Upgrade',
    upgradeAccountResale: 'Submit',
    updateAccount: 'Update',
    or: 'Or',
    socialRegistrationMessage: 'Sign in with a social network',
    submitFacebookFormButtonText: 'FACEBOOK',
    submitGoogleFormButtonText: 'GOOGLE',

    oneClubRegisterSuccessText: 'Thank you for creating a One Club Account. An email has been sent to the provided email address. After you verify your email address you can access you account.',
    ballotOneClubSignInSuccessText: 'You already have a One Club Account. No other action is needed.',
    registrationSuccessText: 'Your account has been created successfully.',
    forgotPasswordSuccessText: 'An email with more information was sent to the provided address.',
    newPasswordRequiredSuccessText: 'Your password has been updated successfully',
    updateUserDetailsSuccessText: 'Your details have been updated successfully.',

    somethingWentWrong: 'Something went wrong.',
    encounteredAnIssueTO: 'We are experiencing extremely high volumes on the website at the moment. Please try again later.',
    encounteredAnIssueWO: 'We are experiencing extremely high volumes on the website at the moment. Please try again later.',

    upgradeToTicketingAccount: 'Complete your profile',
    upgradeToTicketingAccountFromResale: 'We just need a few more details…',
    personaliseYourExperienceMessage: 'Update your profile so we may enhance and personalise your experience',
    alreadyHaveATicketingAccount: 'Already have a Ticketing Account',

    upgradeToOneClubAccount: 'Upgrade to One Club Account',
    alreadyHaveAOneClubAccount: 'Already have a One Club Account',
    completeToOneClubAccount: 'Complete your One Club profile',

    noOrdersFoundText: 'You do not have any orders in your account',
    noProductsFoundText: 'You do not have any products',
    noPaymentSummaryFoundText: 'No payment summary found',
    noDeliveryDataFoundText: 'No delivery data found',
    noHistoryDataFoundText: 'No history data found',
    noActionsToPerformText: 'There are no actions to perform',
    noUpcomingEventText: 'There is no upcoming event',

    emptyString: '',
    defaultNumberValue: 0,

    upcoming: 'Upcoming',
    actionsToPerform: 'Actions for you to perform',
    actions: 'Actions',
    fileSummary: 'File summary',
    paymentSummary: 'Payment summary',
    installments: 'Installments',
    delivery: 'Delivery',
    changeHistory: 'Change history',
    unitPrice: 'Unit Price',
    subTotal: 'Sub-total',
    qty: 'Qty',
    invoice: 'Invoice',
    date: 'Date',
    order: 'Order',
    type: 'Type',
    open: 'Open',
    documentsPdf: 'Documents (PDF)',
    confirmed: 'Confirmed',
    documents: 'Documents',
    deliveryMethod: 'Delivery method',
    shipmentState: 'Shipment state',
    deliveryAddress: 'Delivery address',
    totalAmountPaid: 'Total amount paid',
    dueDate: 'Due Date',
    amountDue: 'Amount Due',
    amountPaid: 'Amount Paid',
    paymentDate: 'Payment Date',
    payByCreditCard: 'Pay by credit card',
    amountInvoiced: 'Invoiced amount',
    paymentMethod: 'Payment method',
    lastStatus: 'Last status',
    lastPayment: 'Last payment',
    billingContactName: 'Billing Contact Name',
    billingContactDetails: 'Billing Contact Details',
    billingAddress: 'Billing Address',
    addressLine1: 'Address Line 1',
    addressLine2: 'Address Line 2',
    addressLine3: 'Address Line 3',
    city: 'Town/City',
    country: 'Country',
    county: 'County',
    printSummary: 'Print summary',
    payReservation: 'Pay reservation',
    lastOrderText: 'Your last order',
    fileNumber: 'File number',
    fileContent: 'File content',
    channel: 'Channel',
    fileStatus: 'Status',
    fileContact: 'File Contact',
    lastUpdate: 'Last update',
    created: 'Created',
    file: 'File',
    fileAmount: 'File amount',
    expirationDate: 'Expiration Date',
    expiryDate: 'Expiry Date',
    viewFileDetails: 'View file details',
    information: 'Information',
    display: 'Display',
    close: 'Close',
    cancel: 'Cancel',
    saveAndContinue: 'Save and Continue',
    canceledFiles: 'Canceled files',
    hideOldTickets: 'Hide old tickets',
    ticketNumber: 'Ticket Number',
    firstName: 'First name',
    lastName: 'Last name',
    verifyEmailSuccessText: 'Your new email was successful validated. Thank you!',
    conflictHTTPStatusCode: 409,
    removeAddressConfirmationMessage: 'Yes'
};
